<div class="layout-footer">
    <img src="./assets/layout/images/logo_futhunter.jpeg" alt="Logo" height="20" class="mr-2"/>
    by
    <span class="font-medium ml-2">Fut Hunter</span>
</div>
